import { render, staticRenderFns } from "./EmissaoDeNotas.vue?vue&type=template&id=57b38542"
import script from "./EmissaoDeNotas.vue?vue&type=script&lang=js"
export * from "./EmissaoDeNotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports